import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";
import { connect } from "react-redux";
import { patchProductLink } from 'redux/catalog/actions';
import { Dropdown } from 'semantic-ui-react';
import { Input } from 'semantic-ui-react';
import onClickOutside from "react-onclickoutside";
import CommonErrorIcon from 'components/common/CommonErrorIcon';
import './ProductItemPrice.css';

const ENTER_KEY = 13;

class ProductItemPrice extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    productId: PropTypes.number.isRequired,
    initialPrice: PropTypes.number,
    initialCurrency: PropTypes.number,
  };

  static defaultProps = {
    initialPrice: null,
    initialCurrency: null,
  };

  state = {
    initPrice: null,
    currentPrice: null,
    currentCurrency: null,
    errors: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.initialPrice) {
      this.setState({
        initPrice: Number(this.props.initialPrice),
        currentPrice: Number(this.props.initialPrice),
      });
    }
    this.setState({ currentCurrency: this.props.initialCurrency });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.currentCurrency &&
      prevState.currentCurrency !== this.state.currentCurrency
    ) {
      this._changeValue('currency', this.state.currentCurrency);
    }

    if (
      this.state.currentPrice &&
      prevState.currentPrice !== this.state.currentPrice
    ) {
      this.setState({ errors: null });
      this._executePriceValidation(this.state.currentPrice);
    }

    if (!this.state.currentPrice && prevState.currentPrice) {
      this.setState({ errors: null });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
    this.setState({ errors: null });
  }

  _executePriceValidation = price => {
    let stringAbsolutePrice = String(Math.abs(price));

    if (isNaN(Number(price))) {
      this.setState({ errors: i18n.t("Please must be a number") });
    } else if (Number(price) < 0) {
      this.setState({ errors: i18n.t("Price must not be less than 0") });
    } else if (!isNaN(Number(price))) {
      if (!Number.isInteger(Number(price)) && String(price).split('.').pop().length > 2) {
        this.setState({ errors: i18n.t("More than 2 digits after point") });
      }
      if (String(price).length > 11) {
        this.setState({errors: i18n.t("Ensure that there are no more than 10 digits in total.")});
      }
      if (String(Math.round(stringAbsolutePrice)).length > 8) {
        this.setState({ errors: i18n.t("No more than 8 digits before decimal point")});
      }
    }
  }

  _changeValue = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    this.props.patchProductLink(this.props.productId, form);
  };

  _changePrice = () => {
    if (
      !this.state.errors &&
      this.state.currentPrice !== this.state.initPrice
    ) {
      this._changeValue('price', this.state.currentPrice);
      this.setState({ initPrice: this.state.currentPrice });
    }
  }

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this._changePrice();
    }
  };

  handleClickOutside = () => {
    this._changePrice();
  }

  render() {
    const { currencies } = this.props;
    const { currentPrice, currentCurrency, errors } = this.state;

    const currenciesOptions = currencies ?
      currencies.map(
        currency => (
          {
            key: currency.currency_code,
            text: currency.currency_code,
            value: currency.id,
            symbol: currency.currency_symbol,
          }
        ),
      ) : [];

    return (
      <div className="catalog-product-item-price__component">
        <div className={`price-block${errors ? ' error' : ''}`}>
          <Input
            placeholder="0"
            value={currentPrice}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentPrice: e.target.value });
            }}
          />
         {errors &&
            <div className="errors-text">
              <CommonErrorIcon errorText={errors} />
            </div>
         }
        </div>

        <Dropdown
          fluid
          search
          selection
          value={currentCurrency}
          options={currenciesOptions}
          onChange={(_e, data) => {
            this.setState({ currentCurrency: data.value });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    currencies: state.commonReducer.currencies,
  }
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(onClickOutside(ProductItemPrice));
